import { Input } from 'ui'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'

export const FieldAttributeLabel: FieldAttributesSignature = ({ field }) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Etiqueta</label>
      <Input
        size='sm'
        defaultValue={field.label}
        onChange={(e) =>
          updateField(field.id, {
            label: e.target.value,
          })
        }
      />
    </div>
  )
}
